import { MtTag } from "server/models"
import { OrderType, inferLiteral } from "client/utils"
import * as types from "./types"


export const setTagList = (tagList: types.TagList) => ({
    type: inferLiteral(types.TAG_LIST),
    tagList,
})
export const setTagIds = (tagIds: readonly number[]) => ({
    type: inferLiteral(types.TAG_IDS),
    tagIds,
})
export const setTagEdit = (tag: MtTag) => ({
    type: inferLiteral(types.TAG_EDIT),
    tag,
})
export const setTagSort = (sortColumn: keyof MtTag, sortOrder: OrderType) => ({
    type: inferLiteral(types.TAG_SORT),
    sortColumn,
    sortOrder,
})
export const setTagFilters = (filters: types.TagFilters) => ({
    type: inferLiteral(types.TAG_FILTERS),
    filters,
})
export const setTagReloadList = (value: boolean) => ({
    type: inferLiteral(types.TAG_RELOAD_LIST),
    value,
})
